module.exports = __webpack_public_path__ + "img/folder.dcea65ab.svg";